module.exports = __webpack_public_path__ + "static/img/v1.9001a92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/v1.svg
// module id = tdpD
// module chunks = 0